export default __webpack_public_path__ + "static/media/PACOCA.30e56f6b.svg";